// chat screens' English text (D146). Keys start with "chat.".
export const chat = {
  // CallSummary
  'chat.call.today': 'Today, {time}',
  'chat.call.yesterday': 'Yesterday, {time}',
  'chat.call.seconds': '{n} sec',
  'chat.call.minutes': '{n} min',
  'chat.call.voiceDuration': 'Voice call · {duration}',
  'chat.call.videoDuration': 'Video call · {duration}',
  'chat.call.missedVoice': 'Missed voice call',
  'chat.call.missedVideo': 'Missed video call',
  'chat.call.declined': 'Call declined',
  'chat.call.youDeclined': 'You declined a call',
  'chat.call.youCancelled': 'You cancelled a call',
  'chat.call.noAnswer': 'No answer',
  'chat.call.missed': 'Missed',
  'chat.call.missedNotice': 'You missed this call',
  'chat.call.callBack': 'Call back',
  // ChatHeader
  'chat.header.typingOne': '{name} is typing…',
  'chat.header.typingTwo': '{first} and {second} are typing…',
  'chat.header.typingMany': 'Several people are typing…',
  'chat.header.unmute': 'Turn on notifications for this chat',
  'chat.header.mute': 'Mute notifications for this chat',
  'chat.header.everyone': 'Everyone',
  'chat.header.people': '{n} people',
  'chat.header.back': 'Back to chats',
  'chat.header.search': 'Search this chat',
  'chat.header.voiceCall': 'Voice call',
  'chat.header.videoCall': 'Video call',
  'chat.header.more': 'More chat options',
  'chat.header.groupSettings': 'Group info',
  'chat.header.whatDoYouCall': 'What do you call {name}?',
  'chat.header.securityCodes': 'Security codes',
  // Report and block (M58, D207, D208)
  'chat.header.report': 'Report…',
  'chat.header.block': 'Block {name}',
  'chat.report.title': 'Report {name}',
  'chat.report.reasonLabel': 'What’s wrong?',
  'chat.report.reason.harassment': 'Harassment or abuse',
  'chat.report.reason.spam': 'Spam or scam',
  'chat.report.reason.impersonation': 'Pretending to be someone',
  'chat.report.reason.other': 'Something else',
  'chat.report.chooseReason': 'Choose a reason',
  'chat.report.noteLabel': 'Anything to add? (optional)',
  'chat.report.notePlaceholder': 'What happened',
  'chat.report.noteTooLong': 'Keep the note to {max} characters',
  'chat.report.alsoBlock': 'Also block {name}',
  'chat.report.alsoBlockHint':
    'They won’t be able to message or call you directly. Family groups stay as they are.',
  'chat.report.privacy':
    'Twinden can’t read your messages, so a report says who and why, not what was said. Your family’s roots and Twinden see it.',
  'chat.report.send': 'Send report',
  'chat.report.sent': 'Report sent. Thank you.',
  'chat.report.failed': 'Couldn’t send the report',
  'chat.block.title': 'Block {name}?',
  'chat.block.body':
    'They won’t be able to message or call you directly, and your chat with them is hidden. They won’t be told. Family groups stay as they are. You can unblock in Settings.',
  'chat.block.confirm': 'Block',
  'chat.block.done': '{name} is blocked',
  'chat.block.failed': 'Couldn’t block them',
  'chat.reported.title': 'A member was reported in {family}',
  'chat.reported.hint': 'See it in Manage family → Reports.',
  // ConversationDialogs
  'chat.dialogs.groupCreated': 'Group created',
  'chat.dialogs.couldNotCreateGroup': 'Could not create group',
  'chat.dialogs.newGroup': 'New group',
  'chat.dialogs.groupName': 'Group name',
  'chat.dialogs.groupNamePlaceholder': 'e.g. Weekend plans',
  'chat.dialogs.members': 'Members',
  'chat.dialogs.nobodyElse': 'There is nobody else in this family yet.',
  'chat.dialogs.createGroup': 'Create group',
  'chat.dialogs.couldNotOpenChat': 'Could not open chat',
  'chat.dialogs.newChat': 'New chat',
  'chat.dialogs.searchMembers': 'Search family members',
  'chat.dialogs.noMatch': 'No family members match.',
  'chat.dialogs.groupRenamed': 'Group renamed',
  'chat.dialogs.couldNotRename': 'Could not rename group',
  'chat.dialogs.membersAdded': 'Members added',
  'chat.dialogs.couldNotAdd': 'Could not add members',
  'chat.dialogs.confirmRemove': 'Remove this person from the group?',
  'chat.dialogs.couldNotRemove': 'Could not remove member',
  'chat.dialogs.couldNotChangeRole': 'Could not change role',
  'chat.dialogs.confirmLeave': 'Leave this group?',
  'chat.dialogs.leftGroup': 'Left group',
  'chat.dialogs.couldNotLeave': 'Could not leave group',
  'chat.dialogs.confirmDelete': 'Delete this group for everyone?',
  'chat.dialogs.groupDeleted': 'Group deleted',
  'chat.dialogs.couldNotDelete': 'Could not delete group',
  'chat.dialogs.name': 'Name',
  'chat.dialogs.membersCount': 'Members ({n})',
  'chat.dialogs.youSuffix': '(you)',
  'chat.dialogs.admin': 'Admin',
  'chat.dialogs.demote': 'Demote',
  'chat.dialogs.promote': 'Promote',
  'chat.dialogs.addMembers': 'Add family members',
  'chat.dialogs.addSelected': 'Add selected',
  'chat.dialogs.leave': 'Leave',
  // ConversationList (home)
  'chat.home.sentPhoto': 'Sent a photo',
  'chat.home.encrypted': 'Encrypted message',
  'chat.home.declinedVoice': 'Declined voice call',
  'chat.home.declinedVideo': 'Declined video call',
  'chat.home.cancelledVoice': 'Cancelled voice call',
  'chat.home.cancelledVideo': 'Cancelled video call',
  'chat.home.sentGif': 'Sent a gif',
  'chat.home.sentVideo': 'Sent a video',
  'chat.home.sentVoice': 'Sent a voice note',
  'chat.home.sentFile': 'Sent a file',
  'chat.home.sentThing': 'Sent a {thing}',
  'chat.home.whoSentPhoto': '{name} sent a photo',
  'chat.home.whoSentGif': '{name} sent a gif',
  'chat.home.whoSentVideo': '{name} sent a video',
  'chat.home.whoSentVoice': '{name} sent a voice note',
  'chat.home.whoSentFile': '{name} sent a file',
  'chat.home.whoSentThing': '{name} sent a {thing}',
  'chat.home.search': 'Search chats and messages',
  'chat.home.family': 'Family',
  'chat.home.chatWith': 'Chat with {name}',
  'chat.home.chatWithNew': 'Chat with {name}, new messages',
  'chat.home.myBirthday': 'Happy birthday! Have a lovely day.',
  // Festival mode (D310): the header touch's name.
  'chat.home.festivalTouch': '{name} today',
  'chat.home.birthdayToday': 'Today is {name}’s birthday',
  'chat.home.wishThem': 'Wish them',
  'chat.siblings.label': 'A festival wish for your brothers and sisters',
  'chat.siblings.one': 'Send {name} a {festival} wish',
  'chat.siblings.many': 'Send a {festival} wish',
  'chat.siblings.wish': 'Wish',
  'chat.siblings.wishName': 'Send {name} a {festival} wish',
  'chat.siblings.dismiss': 'Not this year',
  'chat.home.mentionsOne': '1 new mention',
  'chat.home.mentionsOther': '{n} new mentions',
  'chat.home.newCount': '{n} new',
  'chat.home.muted': 'Muted',
  'chat.home.helloEveryone': 'Say hello to the whole family',
  'chat.home.unreadSuffix': ', {n} unread',
  'chat.home.mutedSuffix': ', muted',
  'chat.home.hello': 'Say hello',
  'chat.home.messages': 'Messages',
  'chat.home.nothingMatches': 'Nothing matches “{query}”',
  'chat.home.noChats': 'No chats in this family yet',
  // ConversationSearch
  'chat.unknown': 'Unknown',
  'chat.search.failed': 'Search failed',
  'chat.search.close': 'Close search',
  'chat.search.noMatch': 'No messages match “{query}”',
  'chat.search.typeAtLeast': 'Type at least {n} characters',
  // DeleteMessageDialog
  'chat.message.deleted': 'This message was deleted',
  'chat.delete.forMeBody':
    'It will be hidden from your view only. Everyone else still sees it.',
  'chat.delete.forEveryoneBody':
    'Everyone in this chat will see “This message was deleted”. You can’t undo this.',
  'chat.delete.adminBody':
    'As a family admin you can remove {name}’s message for everyone; that is recorded in the family’s audit log.',
  'chat.delete.adminBodyNoName':
    'As a family admin you can remove their’s message for everyone; that is recorded in the family’s audit log.',
  'chat.delete.title': 'Delete this message?',
  'chat.delete.titleForMe': 'Delete it for you?',
  'chat.delete.forEveryone': 'Delete for everyone',
  'chat.delete.forMe': 'Delete for me',
  'chat.delete.keep': 'Keep it',
  // FileCard
  'chat.file.badge': 'FILE',
  'chat.file.couldNotDownload': 'Could not download {name}',
  'chat.file.downloading': 'Downloading {name}',
  'chat.file.progress': '{done} of {total}',
  'chat.file.starting': 'Starting…',
  'chat.file.cancel': 'Cancel download',
  'chat.file.download': 'Download {name}',
  // ForwardDialog
  'chat.forward.title': 'Forward',
  'chat.forward.selected': '{n}/{max} selected',
  // GettingKeysNotice
  'chat.keys.getting': 'Getting your messages from your other device…',
  'chat.keys.unlocked': 'Your messages are unlocked',
  'chat.keys.hide': 'Hide',
  // GreetingSheet and occasion names (lib/greetings.ts)
  'chat.greeting.title': 'Send a greeting',
  'chat.greeting.pick':
    'Pick the occasion. You can change the words before it goes.',
  'chat.greeting.occasions': 'Occasions',
  'chat.greeting.another': 'Choose another occasion',
  'chat.greeting.card': '{name} card',
  'chat.greeting.cardLabel': '{name} card: {line}',
  'chat.greeting.yours': 'Your greeting',
  'chat.greeting.send': 'Send card',
  'chat.greeting.diwali': 'Diwali',
  'chat.greeting.holi': 'Holi',
  'chat.greeting.rakshaBandhan': 'Raksha Bandhan',
  'chat.greeting.eid': 'Eid',
  'chat.greeting.christmas': 'Christmas',
  'chat.greeting.pongal': 'Pongal',
  'chat.greeting.onam': 'Onam',
  'chat.greeting.navratri': 'Navratri',
  'chat.greeting.lohri': 'Lohri',
  'chat.greeting.karvaChauth': 'Karva Chauth',
  'chat.greeting.durgaPuja': 'Durga Puja',
  'chat.greeting.newYear': 'New Year',
  'chat.greeting.birthday': 'Birthday',
  'chat.greeting.anniversary': 'Anniversary',
  'chat.greeting.eidAlAdha': 'Bakrid',
  'chat.greeting.getWell': 'Get well soon',
  // A soft hyphen: the word is wider than a picker tile on a 360px phone.
  'chat.greeting.congratulations': 'Congratu\u00ADlations',
  'chat.greeting.thankYou': 'Thank you',
  // When a festival's card is offered (D176)
  'chat.greeting.today': 'Today: {name}',
  'chat.greeting.soon': 'Coming up: {name}',
  'chat.greeting.belated': 'Belated: {name}',
  'chat.greeting.anyDay': 'For any day',
  // Designs and ready-made wishes (D269)
  'chat.greeting.designs': 'Designs',
  'chat.greeting.design': '{name}, design {n} of {total}',
  'chat.greeting.scrollBack': 'Scroll back',
  'chat.greeting.scrollOn': 'Scroll on',
  'chat.greeting.wishes': 'Ready-made wishes',
  // The days inside Diwali, Navratri and Durga Puja (D269)
  'chat.greeting.day.dhanteras': 'Dhanteras',
  'chat.greeting.day.chhotiDiwali': 'Chhoti Diwali',
  'chat.greeting.day.lakshmiPuja': 'Lakshmi Puja',
  'chat.greeting.day.govardhanPuja': 'Govardhan Puja',
  'chat.greeting.day.bhaiDooj': 'Bhai Dooj',
  'chat.greeting.day.navratriAshtami': 'Durga Ashtami',
  'chat.greeting.day.navratriNavami': 'Maha Navami',
  'chat.greeting.day.durgaShashthi': 'Maha Shashthi',
  'chat.greeting.day.durgaSaptami': 'Maha Saptami',
  'chat.greeting.day.durgaAshtami': 'Maha Ashtami',
  'chat.greeting.day.durgaNavami': 'Maha Navami',
  'chat.greeting.day.vijayadashami': 'Vijayadashami',
  // ImageLightbox
  'chat.viewer.saved': 'Saved to your downloads',
  'chat.viewer.couldNotDownload': 'Could not download the photo',
  'chat.viewer.download': 'Download',
  'chat.viewer.downloading': 'Downloading photo',
  'chat.viewer.toDocuments': 'To Documents',
  'chat.viewer.starred': 'Starred',
  'chat.viewer.star': 'Star',
  'chat.viewer.goToChat': 'Go to chat',
  // Message type labels (replyLabel)
  'chat.type.image': 'Photo',
  'chat.type.video': 'Video',
  'chat.type.voice': 'Voice note',
  'chat.type.file': 'File',
  // MentionPicker
  'chat.mention.pick': 'Mention someone',
  // MessageActionSheet and messageActionItems
  'chat.actions.copied': 'Copied',
  'chat.actions.couldNotCopy': 'Could not copy',
  'chat.actions.label': 'Message actions',
  'chat.actions.react': 'React',
  'chat.actions.reactWith': 'React {emoji}',
  'chat.actions.reply': 'Reply',
  'chat.actions.copy': 'Copy text',
  'chat.actions.edit': 'Edit',
  'chat.actions.unstar': 'Unstar message',
  'chat.actions.star': 'Star message',
  'chat.actions.unpin': 'Unpin',
  'chat.actions.pin': 'Pin to the top',
  'chat.actions.forward': 'Forward…',
  'chat.actions.saveLink': 'Save link to family Links',
  'chat.actions.saveDocument': 'Save to family Documents',
  'chat.actions.info': 'Info',
  'chat.actions.seenCount': '{n} of {total}',
  'chat.actions.delete': 'Delete…',
  'chat.actions.report': 'Report…',
  // MessageBubble
  'chat.message.imageAlt': 'Image attachment',
  'chat.message.photoFailed': 'Couldn’t open this photo',
  'chat.message.loadingVideo': 'Loading video',
  'chat.message.playVideo': 'Play video',
  'chat.message.videoFailed': 'Couldn’t open this video',
  'chat.message.voiceFailed': 'Couldn’t open this voice note',
  'chat.message.locked': 'Locked until a key arrives',
  // M76 (D327): the key is here but it isn't what it claims to be.
  'chat.message.unverified': 'This message can’t be verified',
  // M76 (D328): opened, but from before senders were bound.
  'chat.message.unbound': 'Older message · sender not verified',
  'chat.message.attachment': 'Attachment',
  'chat.message.seenBy': 'Seen by {n}',
  'chat.message.sent': 'Sent',
  'chat.message.seen': 'Seen',
  'chat.message.forwarded': 'Forwarded',
  'chat.message.replyDeleted': 'Message deleted',
  'chat.message.pinned': 'Pinned',
  'chat.message.edited': 'edited',
  'chat.message.includingYou': ', including you',
  // MessageComposer
  'chat.composer.cardFailed': 'Could not make the card',
  'chat.composer.micUnavailable': 'Microphone unavailable',
  'chat.composer.allowMic': 'Allow microphone access to record a voice note.',
  'chat.composer.editFailed': 'Could not edit message',
  'chat.composer.replyingTo': 'Replying to {name}',
  'chat.composer.replyingToMessage': 'Replying to message',
  'chat.composer.editing': 'Editing message',
  'chat.composer.cancelReply': 'Cancel reply',
  'chat.composer.cancelEdit': 'Cancel edit',
  'chat.composer.discardVoice': 'Discard voice note',
  'chat.composer.sendVoice': 'Send voice note',
  'chat.composer.attach': 'Attach photo, video or file, or send a greeting',
  'chat.composer.image': 'Image or GIF',
  'chat.composer.saveEdit': 'Save edit',
  'chat.composer.send': 'Send message',
  'chat.composer.record': 'Record voice note',
  // MessageList and messageUtils
  'chat.list.today': 'Today',
  'chat.list.yesterday': 'Yesterday',
  'chat.list.start': 'Start of conversation',
  // Jump to latest (D271): the round ↓ button's name, with what's new
  'chat.list.jumpLatest': 'Jump to latest messages',
  'chat.list.jumpLatestOne': 'Jump to latest messages, 1 new',
  'chat.list.jumpLatestOther': 'Jump to latest messages, {n} new',
  // NewDeviceBanner
  'chat.newDevice.title': 'This device is new to these messages',
  'chat.newDevice.body':
    'They unlock when Twinden is open on a device you’ve used before, or when someone else in this chat opens it.',
  'chat.newDevice.step1':
    'Open Twinden on your other phone or computer (or a Safari tab you used before).',
  'chat.newDevice.step2': 'Keep Twinden open here too.',
  'chat.newDevice.step3':
    'Wait a few seconds: the messages unlock by themselves.',
  'chat.newDevice.how': 'How?',
  // Key store banners (D262): the browser can't keep this device's key
  'chat.keyStore.blocked.title': 'Your browser is blocking Twinden’s site data',
  'chat.keyStore.blocked.body':
    'Your browser is blocking the site data Twinden needs for your messages’ keys. Allow site data for twinden.com (in Brave: Shields → allow, or turn off ‘Forget me when I close this site’), then reload.',
  'chat.keyStore.broken.title': 'This browser’s storage isn’t working',
  'chat.keyStore.broken.body':
    'This browser’s storage for your messages’ keys isn’t working. Clear site data for twinden.com (DevTools → Application → Clear site data, or Brave settings → Site and Shields settings → twinden.com) and sign in again.',
  'chat.keyStore.ephemeral.title': 'This browser forgets your messages’ keys',
  'chat.keyStore.ephemeral.body':
    'Your browser forgets the site data Twinden needs for your messages’ keys: the key is forgotten when you close the tab, so every visit starts as a new device. Allow site data for twinden.com (in Brave: turn off ‘Forget me when I close this site’), then reload.',
  'chat.keyStore.slow.title': 'Storage is slow on this device',
  'chat.keyStore.slow.body':
    'Twinden couldn’t open the storage that holds your messages’ keys in time. Reload to try again.',
  'chat.keyStore.tooMany.title': 'Too many new devices today',
  'chat.keyStore.tooMany.body':
    'This account has added too many devices today. Try again tomorrow.',
  'chat.keyStore.unsupported.title':
    'This browser can’t use Twinden’s encryption',
  'chat.keyStore.unsupported.body':
    'This browser can’t use Twinden’s encryption. Try another browser, or update this one.',
  'chat.keyStore.unusable.title': 'This device’s key isn’t working',
  'chat.keyStore.unusable.body':
    'This device’s key isn’t working. Sign out and sign in again on this device to get a new one.',
  'chat.keyStore.replaced.title': 'This device’s key couldn’t be used',
  'chat.keyStore.replaced.body':
    'Twinden made a new one. Your messages unlock when Twinden is open on a device you’ve used before, or when someone else in the chat opens it.',
  'chat.keyStore.step1':
    'Brave: click the Shields icon in the address bar, allow site data for twinden.com (or turn Shields off here) and turn off ‘Forget me when I close this site’.',
  'chat.keyStore.step2':
    'Safari: a Private tab forgets everything when it closes. Open twinden.com in a normal tab.',
  'chat.keyStore.step3':
    'Any browser: ‘Block all cookies’ also blocks site data. Allow cookies for twinden.com, then reload this page.',
  // InstallNudge (D184)
  'chat.install.label': 'Install Twinden',
  'chat.install.body':
    'Install Twinden for notifications and a full-screen app',
  'chat.install.install': 'Install',
  'chat.install.how': 'How',
  'chat.install.notNow': 'Not now',
  // The store app instead of the web app, on a phone (D346)
  'chat.install.getApp': 'Get the Twinden app',
  'chat.install.getAppBody':
    'Notifications and calls work best in the app for your phone.',
  'chat.install.openStore': 'Get the app',
  // PinnedBanner
  'chat.pinned.nOfTotal': 'Pinned message {n} of {total}',
  'chat.pinned.one': 'Pinned message',
  // Drafts in the chat list (M62, D228)
  'chat.draft.label': 'Draft:',
  // Unread divider (M62, D229)
  'chat.unread.one': '1 unread message',
  'chat.unread.other': '{n} unread messages',
  // MessageInfoSheet (M62, D227)
  'chat.info.title': 'Message info',
  'chat.info.sent': 'Sent {when}',
  'chat.info.edited': 'Edited {when}',
  'chat.info.when': '{date}, {time}',
  'chat.info.seenBy': 'Seen by',
  'chat.info.notYet': 'Not yet',
  'chat.info.seen': 'Seen',
  'chat.info.nobody': 'Nobody has seen it yet.',
  // SecurityCodeDialog
  'chat.security.noDevices': 'No devices yet',
  'chat.security.them': 'them',
  'chat.security.body':
    'Messages here are end-to-end encrypted. Compare these with {name} in person or on a call: if you both see the same two codes, only your devices can read them.',
  'chat.security.yours': 'Your code',
  'chat.security.theirs': '{name}’s code',
  'chat.security.changes':
    'A code changes when someone adds or removes a phone or computer.',
  // Post-quantum keys (M78, D338, §6.5): codes change once everyone's
  // devices have ML-KEM keys; a device left behind after the grace.
  'chat.codesNeedUpdate':
    'Codes match only when both of you have the latest app.',
  'chat.security.deviceNeedsUpdate': 'One of {name}’s devices needs an update.',
  // This device's own post-quantum status (review M5): comparing codes in
  // person then also catches a key a server stripped.
  'chat.security.thisDeviceSafe': 'This device: quantum-safe key ✓',
  'chat.security.thisDeviceNotSafe':
    'This device doesn’t have a quantum-safe key yet.',
  // MessageList: someone gained a device (M73, D303), this device only
  'chat.devicesChanged': '{name}’s devices changed · Check security code',
  // Someone joined after this device first looked at who was in (D343)
  'chat.memberAdded': '{name} was added to this chat',
  'chat.memberJoinedFamily': '{name} joined the family',
  // OwnDeviceNotice: a new device on my account, from this device's record (M73)
  'chat.ownDeviceAdded':
    'A new device was added to your account · See your devices',
  // VoiceNotePlayer
  'chat.voice.pause': 'Pause voice note',
  'chat.voice.play': 'Play voice note',
  'chat.voice.position': 'Voice note position',
  // PendingBand
  'chat.pending.notSentError': 'Not sent · {error}',
  'chat.pending.notSentTap': 'Not sent · Tap to retry',
  'chat.pending.sendingVideos': 'Sending videos',
  'chat.pending.sendingPhotos': 'Sending photos',
  'chat.pending.videosDone': '{n} of {total} videos',
  'chat.pending.photosDone': '{n} of {total} photos',
  'chat.pending.sending': 'Sending',
  'chat.pending.uploading': 'Uploading, {percent}%',
  'chat.pending.sendingFile': 'Sending {name}',
  'chat.pending.sendingDots': 'Sending…',
  'chat.pending.cancel': 'Cancel sending',
  'chat.pending.notSent': 'Not sent',
  'chat.pending.retrying': 'Connection lost, trying again…',
  // CallOverlay and CallTile
  'chat.callScreen.muted': 'Muted',
  'chat.callScreen.end': 'End call',
  'chat.callScreen.call': 'Call',
  'chat.callScreen.participant': 'Participant',
  'chat.callScreen.calling': 'Calling',
  'chat.callScreen.isCallingGroup': 'is calling {name}',
  'chat.callScreen.isCallingYou': 'is calling you',
  'chat.callScreen.connecting': 'Connecting…',
  // D279: the faces under a chat's name, and a picture big.
  'chat.people.title': 'In this chat · {n}',
  'chat.people.seeWho': 'See who’s in this chat',
  'chat.people.seePhoto': 'See {name}’s picture',
  'chat.people.photoOf': '{name}’s picture',
  // Aashirwad (D280).
  'chat.bless.default': 'Jeete raho 🙏',
  'chat.bless.action': 'Bless (Aashirwad)',
  'chat.bless.quick': 'Bless {name}’s message',
  'chat.callScreen.callingDots': 'Calling…',
  // D278: once their phone is ringing.
  'chat.callScreen.ringingDots': 'Ringing…',
  'chat.callScreen.voiceTitle': 'Twinden voice call',
  'chat.callScreen.videoTitle': 'Twinden video call',
  'chat.callScreen.declineCall': 'Decline call',
  'chat.callScreen.cancelCall': 'Cancel call',
  'chat.callScreen.decline': 'Decline',
  'chat.callScreen.answerCall': 'Answer call',
  'chat.callScreen.answer': 'Answer',
  'chat.callScreen.addSomeone': 'Add someone to the call',
  'chat.callScreen.addTitle': 'Add to the call',
  'chat.callScreen.ringing': 'Ringing {name}…',
  'chat.callScreen.ring': 'Ring',
  'chat.callScreen.minimise': 'Minimise call',
  'chat.callScreen.pictureInPicture': 'Picture in picture',
  'chat.callScreen.inPictureInPicture': 'Showing in picture in picture',
  'chat.callScreen.cameraOff': 'Camera off',
  'chat.callScreen.reconnecting': 'Reconnecting…',
  'chat.callScreen.yourCameraOff': 'Your camera is off',
  'chat.callScreen.muteMic': 'Mute microphone',
  'chat.callScreen.unmuteMic': 'Unmute microphone',
  'chat.callScreen.cameraOffAction': 'Turn camera off',
  'chat.callScreen.cameraOnAction': 'Turn camera on',
  'chat.callScreen.flip': 'Flip camera',
  'chat.callScreen.weakVideoPaused': 'Weak connection — video paused',
  'chat.callScreen.videoBetter': 'Connection better — turn video on?',
  'chat.callScreen.turnVideoOn': 'Turn video on',
  'chat.callScreen.voiceClock': 'Voice · {clock}',
  'chat.callScreen.speaking': 'Speaking',
  'chat.callScreen.mute': 'Mute',
  'chat.callScreen.unmute': 'Unmute',
  'chat.callScreen.backTo': 'Back to the call with {name}',
  'chat.callScreen.yourFamily': 'your family',
  'chat.callScreen.onCallWith': 'On a call with {name}',
  // useCall
  'chat.callErrors.denied': 'Camera and microphone permission was denied',
  'chat.callErrors.notFound': 'No camera or microphone was found',
  'chat.callErrors.inUse': 'Your camera or microphone is in use by another app',
  'chat.callErrors.couldNotStart': 'Could not start the call',
  'chat.callErrors.busy': 'They are on another call',
  'chat.callErrors.ended': 'Call ended',
  'chat.callErrors.unavailable': 'Calls are not available',
  'chat.callErrors.couldNotSwitch': 'Could not switch camera',
  // attachments and outbox
  'chat.send.uploadFailed': 'Upload failed',
  'chat.send.couldNotSend': 'Could not send',
  // ChatPage
  'chat.page.deleteFailed': 'Could not delete message',
  'chat.page.unknownError': 'Unknown error',
  'chat.page.everyoneInChat': 'Everyone in this chat',
  'chat.page.someone': 'Someone',
  'chat.page.tooFarBack': 'That message is too far back to open',
  'chat.page.reactFailed': 'Could not react',
  'chat.page.notificationsFailed': 'Could not change notifications',
  'chat.page.unstarFailed': 'Could not unstar message',
  'chat.page.starFailed': 'Could not star message',
  'chat.page.alreadyInLinks': 'Already in family Links',
  'chat.page.savedToLinks': 'Saved to family Links',
  'chat.page.view': 'View',
  'chat.page.saveLinkFailed': 'Could not save link',
  'chat.page.savedToDocuments': 'Saved to family Documents',
  'chat.page.saveDocumentFailed': 'Could not save document',
  'chat.page.unpinFailed': 'Could not unpin',
  'chat.page.pinFailed': 'Could not pin',
  'chat.page.forwarded': 'Forwarded',
  'chat.page.forwardedTo': 'Forwarded to {n} chats',
  'chat.page.forwardFailed': 'Could not forward',
  'chat.page.editRefused': 'Your edit couldn’t be saved',
  'chat.page.reactionRefused': 'Your reaction couldn’t be saved',
  'chat.page.notInvited': "You haven't been invited yet",
  'chat.page.askRoot': 'Ask your family root for a QR code or an invitation.',
  'chat.page.sayToEveryone': 'Say something to everyone',
  'chat.page.messageTo': 'Message {name}',
  'chat.page.messageGroup': 'Message the group',
  'chat.page.messageThem': 'Message them',
  'chat.page.select': 'Select a conversation to start chatting',
  'chat.page.messageInGroup': 'Message {name}',
  // MentionsPage
  'chat.mentions.title': 'Mentions',
  'chat.mentions.subtitle':
    'When someone @mentions you, or @everyone in a group you’re in',
  'chat.mentions.loading': 'Loading your mentions…',
  'chat.mentions.empty': 'No mentions yet',
  'chat.mentions.emptyBody':
    'When someone writes @{handle} or @everyone, it shows up here.',
  'chat.mentions.itemNew': 'New: {name} in {chat}',
  'chat.mentions.item': '{name} in {chat}',
  'chat.mentions.older': 'Show older mentions',
  // CallsPage
  'chat.calls.video': 'Video',
  'chat.calls.voice': 'Voice',
  'chat.calls.missedVideoOther': 'Missed video calls',
  'chat.calls.missedVoiceOther': 'Missed voice calls',
  'chat.calls.declinedLabel': 'Declined',
  'chat.calls.declined': 'Declined · {kind}',
  'chat.calls.youDeclined': 'You declined · {kind}',
  'chat.calls.outgoing': 'Outgoing',
  'chat.calls.incoming': 'Incoming',
  'chat.calls.cancelled': 'Cancelled · {kind}',
  'chat.calls.noAnswer': 'No answer · {kind}',
  'chat.calls.chat': 'Chat',
  'chat.calls.newCall': 'New call',
  'chat.calls.voiceCallName': 'Voice call {name}',
  'chat.calls.videoCallName': 'Video call {name}',
  'chat.calls.callName': 'Call {name}',
  'chat.calls.callBackName': 'Call {name} back',
  'chat.calls.videoCallBack': 'Video call {name} back',
  'chat.calls.title': 'Calls',
  'chat.calls.all': 'All',
  'chat.calls.missedCount': 'Missed · {n}',
  'chat.calls.loading': 'Loading your calls…',
  'chat.calls.noMissed': 'No missed calls',
  'chat.calls.none': 'No calls yet',
  'chat.calls.caughtUp': 'You’re all caught up.',
  'chat.calls.emptyBody':
    'Calls with {family} show up here. Start one from any chat, or with New call.',
  'chat.calls.earlier': 'Earlier',
  'chat.calls.older': 'Show older calls',
  // Deleted accounts (M51).
  'chat.system.rootHandover':
    'The family’s root deleted their account. {name} is now the root.',
  // SharePage (Share to Twinden, D177–D182)
  'chat.share.title': 'Send to…',
  'chat.share.subtitleFiles': '{n} shared · pick a chat',
  'chat.share.subtitleText': 'Pick a chat to write it in',
  'chat.share.loading': 'Opening what you shared…',
  'chat.share.cancel': 'Cancel sharing',
  'chat.share.chooseChat': 'Chats',
  'chat.share.messagePlaceholder': 'Add a message',
  'chat.share.messageLabel': 'Message',
  'chat.share.pickFirst': 'Pick a chat',
  'chat.share.sendTo': 'Send to {name}',
  'chat.share.writeIn': 'Write in {name}',
  'chat.share.preparing': 'Sending {done} of {total}…',
  'chat.share.cantSendType': 'Twinden can’t send this kind of file',
  'chat.share.tooBig': 'Too big to send (50 MB at most)',
  'chat.share.goneTitle': 'Nothing to share',
  'chat.share.goneBody':
    'This share was sent, cancelled or is more than a day old. Share it again from the other app.',
  'chat.share.failedBody':
    'Twinden couldn’t keep what you shared on this phone. Share it again from the other app.',
  'chat.share.toChats': 'Go to chats',
  'chat.share.skipped': 'Couldn’t send {names}',
  'chat.share.tooBigBody':
    'That was more than Twinden keeps from one share (200 MB). Share fewer files at a time.',

  // Thank-you card at the top of the chats (M55, D197)
  'chat.thanks.label': 'Thank you from Twinden',
  'chat.thanks.coveredMany':
    '{month}: {count} families chipped in {received} and covered Twinden’s {total}. Thank you.',
  'chat.thanks.coveredOne':
    '{month}: {count} family chipped in {received} and covered Twinden’s {total}. Thank you.',
  'chat.thanks.covered':
    '{month}: families chipped in {received} and covered Twinden’s {total}. Thank you.',
  'chat.thanks.shortMany':
    '{month}: {count} families chipped in {received} of Twinden’s {total}. Thank you.',
  'chat.thanks.shortOne':
    '{month}: {count} family chipped in {received} of Twinden’s {total}. Thank you.',
  'chat.thanks.short':
    '{month}: families chipped in {received} of Twinden’s {total}. Thank you.',
  'chat.thanks.noFigures':
    '{month}: Twinden costs {total}, paid for by the families who use it.',
  'chat.thanks.chipIn': 'Chip in',
  'chat.thanks.ok': 'OK',
  'chat.thanks.safari': 'Open twinden.com in Safari to chip in',
  // M60 (docs/chat-round-three.md)
  'chat.type.album': 'Photos',
  'chat.type.poll': 'Poll',
  'chat.type.unknown': 'Message',
  'chat.message.updateApp': 'Update Twinden to see this message',
  'chat.home.sentPhotos': 'Sent {n} photos',
  'chat.home.sentVideos': 'Sent {n} videos',
  'chat.home.sentMixed': 'Sent {n} photos and videos',
  'chat.home.whoSentPhotos': '{name} sent {n} photos',
  'chat.home.whoSentVideos': '{name} sent {n} videos',
  'chat.home.whoSentMixed': '{name} sent {n} photos and videos',
  'chat.album.count': '{n} to send',
  'chat.album.remove': 'Remove {name}',
  'chat.album.clear': 'Don’t send these',
  'chat.album.captionPlaceholder': 'Add a caption',
  'chat.album.send': 'Send album',
  'chat.album.open': 'Open {n} of {total}',
  'chat.album.label': 'Album of {n}',
  'chat.viewer.position': '{n} of {total}',
  'chat.viewer.previous': 'Previous',
  'chat.viewer.next': 'Next',
  'chat.composer.photosVideos': 'Photos and videos',
  'chat.composer.poll': 'Poll',
  'chat.composer.gathering': 'Gathering',
  'chat.poll.quote': 'Poll: {question}',
  'chat.poll.title': 'New poll',
  'chat.poll.question': 'Question',
  'chat.poll.questionPlaceholder': 'Ask something',
  'chat.poll.options': 'Options',
  'chat.poll.option': 'Option {n}',
  'chat.poll.addOption': 'Add an option',
  'chat.poll.removeOption': 'Remove option {n}',
  'chat.poll.multiple': 'Allow several answers',
  'chat.poll.closeAfter': 'Close after',
  'chat.poll.never': 'Never',
  'chat.poll.hour': '1 hour',
  'chat.poll.day': '1 day',
  'chat.poll.week': '1 week',
  'chat.poll.visibleVotes': 'Everyone in the chat sees who voted for what.',
  'chat.poll.create': 'Send poll',
  'chat.poll.invalid': 'Add a question and at least two options',
  'chat.poll.chooseOne': 'Choose one',
  'chat.poll.chooseAny': 'Choose any',
  'chat.poll.vote': 'Vote',
  'chat.poll.votesOne': '1 vote',
  'chat.poll.votesOther': '{n} votes',
  'chat.poll.changeVote': 'Change vote',
  'chat.poll.retract': 'Take back my vote',
  'chat.poll.close': 'Close poll',
  'chat.poll.closed': 'Poll closed',
  'chat.poll.closesAt': 'Closes {time}',
  'chat.poll.voteFailed': 'Couldn’t save your vote',
  'chat.poll.closeFailed': 'Couldn’t close the poll',
  'chat.poll.needsKeys':
    'Polls are end-to-end encrypted: wait a moment while this device gets its keys.',
  'chat.poll.votedBy': 'Voted: {names}',
  'chat.poll.locked': 'Waiting for this poll’s key…',
  // M71 (docs/gatherings.md, D282)
  'chat.type.gathering': 'Gathering',
  'chat.gathering.today': 'Today, {time}',
  'chat.gathering.tomorrow': 'Tomorrow, {time}',
  'chat.gathering.needsKeys':
    'Gatherings are end-to-end encrypted: wait a moment while this device gets its keys.',
  'chat.gathering.title': 'Dinner call',
  'chat.gathering.titleLabel': 'What is it?',
  'chat.gathering.titlePlaceholder': 'Dinner',
  'chat.gathering.quickBreakfast': 'Breakfast',
  'chat.gathering.quickLunch': 'Lunch',
  'chat.gathering.quickDinner': 'Dinner',
  'chat.gathering.quickChai': 'Chai',
  'chat.gathering.quickMovie': 'Movie',
  'chat.gathering.quickOuting': 'Outing',
  'chat.gathering.quickMeetUp': 'Meet up',
  'chat.gathering.day': 'Day',
  'chat.gathering.dayToday': 'Today',
  'chat.gathering.dayTomorrow': 'Tomorrow',
  'chat.gathering.dayPick': 'Pick a date',
  'chat.gathering.time': 'Time',
  'chat.gathering.place': 'Where (optional)',
  'chat.gathering.placePlaceholder': 'Nani’s terrace',
  'chat.gathering.note': 'A note (optional)',
  'chat.gathering.notePlaceholder': 'Bring the cards',
  'chat.gathering.rings': 'Ring people when it’s time',
  'chat.gathering.ringsHint':
    'People who haven’t said “not today” get a ring when you tap Come now.',
  'chat.gathering.visible': 'Everyone in the chat sees who’s coming',
  'chat.gathering.create': 'Send',
  'chat.gathering.timeError': 'Pick a time from now to 60 days ahead.',
  'chat.gathering.coming': 'Coming',
  'chat.gathering.late': 'Late',
  'chat.gathering.not': 'Not today',
  'chat.gathering.here': 'I’m here',
  'chat.gathering.lateBy': '+{n} min',
  'chat.gathering.takeBack': 'Take back my answer',
  'chat.gathering.lateMenu': 'How late?',
  'chat.gathering.comeNow': 'Come now',
  'chat.gathering.ringDinner': 'Dinner is ready — come now',
  'chat.gathering.ringTitle': '{title} — come now',
  'chat.gathering.ringGeneric': 'Come now',
  'chat.gathering.ringComing': 'I’m coming',
  'chat.gathering.ringSnooze': '5 more minutes',
  'chat.gathering.cancel': 'Cancel',
  'chat.gathering.cancelConfirm': 'Cancel this gathering?',
  'chat.gathering.cancelKeep': 'Keep it',
  'chat.gathering.cancelYes': 'Cancel it',
  'chat.gathering.ended': 'Ended',
  'chat.gathering.cancelled': 'Cancelled',
  'chat.gathering.countComing': '{n} coming',
  'chat.gathering.countLate': '{n} late',
  'chat.gathering.countNot': '{n} not today',
  'chat.gathering.countUnanswered': '{n} haven’t said',
  'chat.gathering.noneYet': 'No one has answered yet',
  'chat.gathering.groupComing': 'Coming',
  'chat.gathering.groupLate': 'Late',
  'chat.gathering.groupNot': 'Not today',
  'chat.gathering.lateName': '{name} (+{n} min)',
  'chat.gathering.atTable': '{n} of {total} at the table',
  'chat.gathering.ringsLimit': 'Already rung twice',
  'chat.gathering.ringsTooSoon': 'Wait 3 minutes between rings',
  'chat.gathering.ringsOff': 'Ringing is off for this one',
  'chat.gathering.invalid':
    'That gathering’s title or note is too long, or the title is empty.',
  'chat.gathering.replyFailed': 'Couldn’t save your answer',
  'chat.gathering.arriveFailed': 'Couldn’t say you’re here',
  'chat.gathering.ringFailed': 'Couldn’t ring',
  'chat.gathering.cancelFailed': 'Couldn’t cancel',
  'chat.gathering.errEnded': 'This gathering has ended.',
  'chat.gathering.errLimit': 'Already rung twice.',
  'chat.gathering.errTooSoon': 'Wait 3 minutes between rings.',
  'chat.gathering.errRingsOff': 'Rings are off for this gathering.',
  'chat.gathering.errCancelNotAllowed': 'Only the one who made it can cancel.',
  'chat.gathering.errRingNotAllowed':
    'Only the one who made it, or a family admin, can ring.',
  'chat.gathering.errInPast': 'That time has already passed.',
  'chat.gathering.errTooFar':
    'That’s too far ahead: pick a day within 60 days.',
  'chat.voice.speed': 'Playback speed {speed}',
  // M63 chat round five (D231–D235)
  'chat.chatActions.label': 'Chat options',
  'chat.chatActions.more': 'More for {name}',
  'chat.chatActions.markRead': 'Mark as read',
  'chat.chatActions.markUnread': 'Mark as unread',
  'chat.chatActions.mute': 'Mute…',
  'chat.chatActions.unmute': 'Unmute',
  'chat.chatActions.mutedUntil': 'Muted until {time}',
  'chat.chatActions.mutedAlways': 'Muted',
  'chat.chatActions.archive': 'Archive',
  'chat.chatActions.unarchive': 'Unarchive',
  'chat.chatActions.keepArchived': 'Keep archived',
  // Quiet, too, unless someone @mentions me (D306).
  'chat.chatActions.keepArchivedHint':
    'New messages won’t bring it back or notify you',
  'chat.chatActions.failed': 'Couldn’t change that chat',
  'chat.chatActions.archived': 'Archived',
  'chat.chatActions.unarchived': 'Back in your chats',
  'chat.archived.row': 'Archived',
  'chat.archived.rowCount': 'Archived · {n}',
  'chat.archived.title': 'Archived',
  'chat.archived.back': 'Back to chats',
  'chat.archived.empty': 'Nothing archived',
  'chat.archived.hint':
    'Archived chats come back when a new message arrives, unless you keep them archived.',
  'chat.archived.unreadSuffix': ', something new',
  'chat.mute.title': 'Mute {name}',
  'chat.mute.body':
    'No notifications or sounds. The chat stays in your list, and @mentions still reach you.',
  'chat.mute.eightHours': '8 hours',
  'chat.mute.oneWeek': '1 week',
  'chat.mute.always': 'Always',
  'chat.mute.done': 'Muted',
  'chat.mute.undone': 'Notifications back on',
  'chat.header.muteEllipsis': 'Mute…',
  'chat.header.mutedUntil': 'Muted until {time}',
  'chat.info.picture': 'Group picture',
  'chat.info.changePicture': 'Change picture',
  'chat.info.removePicture': 'Remove',
  'chat.info.pictureUpdated': 'Group picture changed',
  'chat.info.pictureRemoved': 'Group picture removed',
  'chat.info.pictureFailed': 'Couldn’t change the picture',
  'chat.info.description': 'Description',
  'chat.info.descriptionPlaceholder': 'What this group is for',
  'chat.info.descriptionCount': '{n} of {max}',
  'chat.info.noDescription': 'No description yet',
  'chat.info.descriptionLocked': 'Waiting for the key to show the description…',
  'chat.info.encryptedNote':
    'The description is end-to-end encrypted. Everyone in the group can change the name, picture and description.',
  'chat.info.adminsOnlyNote':
    'Only family roots and admins change the family group.',
  'chat.info.saved': 'Group info saved',
  'chat.info.saveFailed': 'Couldn’t save group info',
  'chat.info.keysNotReady':
    'This device is still getting its keys. Try again in a moment.',
  'chat.system.groupRenamed': '{name} changed the group name to “{group}”',
  'chat.system.groupPicture': '{name} changed the group picture',
  'chat.system.groupPictureRemoved': '{name} removed the group picture',
  'chat.system.groupDescription': '{name} changed the group description',
  'chat.actions.replyPrivately': 'Reply privately',
  'chat.replyPrivately.blocked': 'You can’t message this person',
  'chat.replyPrivately.failed': 'Couldn’t open the chat',
  // M64 (docs/chat-round-six.md): pins, disappearing, send later.
  'chat.chatActions.pin': 'Pin to top',
  'chat.chatActions.unpin': 'Unpin',
  'chat.chatActions.pinLimit': 'You can pin up to {n} chats',
  'chat.home.pinnedSuffix': ', pinned',
  'chat.disappearing.title': 'Disappearing messages',
  'chat.disappearing.body':
    'New messages in this chat disappear for everyone after the time you pick. Messages sent before stay as they are.',
  'chat.disappearing.off': 'Off',
  'chat.disappearing.24h': '24 hours',
  'chat.disappearing.7d': '7 days',
  'chat.disappearing.90d': '90 days',
  'chat.disappearing.current': 'Current',
  'chat.disappearing.headerOn': 'Disappearing messages: {time}',
  'chat.disappearing.failed': 'Couldn’t change disappearing messages',
  'chat.disappearing.turnedOn': 'New messages will disappear after {time}',
  'chat.disappearing.turnedOff': 'Disappearing messages are off',
  'chat.system.disappearingOn':
    '{name} turned on disappearing messages ({time})',
  'chat.system.disappearingOff': '{name} turned off disappearing messages',
  'chat.message.disappears': 'Disappears {time}',
  'chat.composer.sendLater': 'Send later…',
  'chat.sendLater.title': 'Send later',
  'chat.sendLater.body':
    'Pick when it goes. It’s sealed on this device now and sent at that time.',
  'chat.sendLater.inAnHour': 'In 1 hour',
  'chat.sendLater.tonight': 'Tonight, {time}',
  'chat.sendLater.tomorrow': 'Tomorrow, {time}',
  'chat.sendLater.pick': 'Or pick a date and time',
  'chat.sendLater.schedule': 'Schedule',
  'chat.sendLater.tooSoon': 'Pick a time at least 5 minutes from now',
  'chat.sendLater.tooFar': 'Pick a time in the next 30 days',
  'chat.sendLater.needText': 'Type the message first',
  'chat.sendLater.textOnly': 'Only text messages can be sent later',
  'chat.sendLater.needsKeys':
    'This device is still getting its keys. Try again in a moment.',
  'chat.sendLater.done': 'Scheduled for {time}',
  'chat.sendLater.failed': 'Couldn’t schedule that message',
  'chat.scheduled.list': 'Scheduled messages',
  'chat.scheduled.label': 'Scheduled · {time}',
  'chat.scheduled.sendNow': 'Send now',
  'chat.scheduled.cancel': 'Cancel scheduled message',
  'chat.scheduled.cancelled': 'Scheduled message cancelled',
  'chat.scheduled.needsPhone': 'Needs your phone to send',
  'chat.scheduled.locked': 'Encrypted message',
  'chat.scheduled.failed': 'Couldn’t change that scheduled message',
  'chat.scheduled.sent': 'Sent',
  'chat.scheduled.resealing': 'Sealing again for the new key…',
  'chat.sendLater.invalid': 'Pick a date and time',
  // EmojiPicker (M69, D263–D265)
  'chat.emoji.open': 'Emoji',
  'chat.emoji.keyboard': 'Back to the keyboard',
  'chat.emoji.picker': 'Emoji picker',
  'chat.emoji.search': 'Search emoji',
  'chat.emoji.noResults': 'No emoji for “{query}”',
  'chat.emoji.loading': 'Loading emoji…',
  'chat.emoji.failed': 'Couldn’t load the emoji. Try again when you’re online.',
  'chat.emoji.retry': 'Try again',
  'chat.emoji.categories': 'Emoji categories',
  'chat.emoji.recent': 'Recently used',
  'chat.emoji.noRecent': 'Emojis you use show up here',
  'chat.emoji.group.0': 'Smileys and feelings',
  'chat.emoji.group.1': 'People and body',
  'chat.emoji.group.3': 'Animals and nature',
  'chat.emoji.group.4': 'Food and drink',
  'chat.emoji.group.5': 'Travel and places',
  'chat.emoji.group.6': 'Activities',
  'chat.emoji.group.7': 'Objects',
  'chat.emoji.group.8': 'Symbols',
  'chat.emoji.group.9': 'Flags',
  'chat.emoji.results': 'Search results',
  'chat.emoji.skinTone': 'Skin tone',
  'chat.emoji.tone.none': 'Default',
  'chat.emoji.tone.light': 'Light',
  'chat.emoji.tone.medium-light': 'Medium-light',
  'chat.emoji.tone.medium': 'Medium',
  'chat.emoji.tone.medium-dark': 'Medium-dark',
  'chat.emoji.tone.dark': 'Dark',
  'chat.emoji.more': 'More reactions',
  'chat.emoji.reactTitle': 'React with any emoji',
} as const;
